var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import styles from './cookie-button.component.scss';
import { Component, h } from 'preact';
var CookieButton = /** @class */ (function (_super) {
    __extends(CookieButton, _super);
    function CookieButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieButton.prototype.render = function (props) {
        var _this = this;
        var styling = styles['cookie-btn'];
        switch (props.type) {
            case 'primary':
                styling += " " + styles['cookie-btn-primary'];
                break;
            case 'secondary':
                styling += " " + styles['cookie-btn-secondary'];
                break;
        }
        return (h("button", { class: styling, onClick: function (ev) { _this.props.buttonUpdate(ev, _this.props.info); } }, props.label));
    };
    return CookieButton;
}(Component));
export default CookieButton;



//////////////////
// WEBPACK FOOTER
// ./components/cookie-button/cookie-button.component.tsx
// module id = null
// module chunks = 